<div class="warning-popup-wrapper" fxFlex="0 0 100%" fxLayout="column">
  <div fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="space-between center" class="mat-header">
    <div></div>
    <label>Save Your Work</label>
    <i class="far fa-times" [mat-dialog-close]="false" automation-id="save-your-work-icon-back-and-forth-warning"></i>
  </div>
  <div class="mat-body" fxFlex="0 0 auto" fxLayout="column" fxLayoutGap="20px">
    <label>You must save your work before you leave this page. Please click Save Your Work to continue.</label>
    <mat-checkbox class="checkbox" (click)="doNotShow()" automation-id="checkbox-do-not-show-again-back-and-forth-warning"> Don't show again</mat-checkbox>
  </div>
</div>
